// extracted by mini-css-extract-plugin
export default {"heading_container":"PageHeader_heading_container__87XXH","heading":"PageHeader_heading__FJEqu"};